import { jp } from './common'
import fba from './FBA/ja-JP'
import fund from './funding/ja-JP'
import saledFeedback from './feedback/ja-JP'
import recharge from './recharge/ja-JP'
import cnumber from './cNumber/ja-JP'
import cs from './ws/ja-JP'


const t = {
  common: jp,
  fba,
  fund,
  saledFeedback,
  recharge,
  cnumber,
}

t.loading = '読み込み中'

t.brand = {}
t.brand.lg = '中日速達-クライアント'
t.brand.mini = '中日'

t.add = '新規'
t.delete = '削除'
t.deleteBatch = '削除'
t.update = '修正'
t.query = '検索'
t.export = 'ダウンロード'
t.handle = '操作'
t.confirm = '確定'
t.cancel = 'キャンセル'
t.logout = 'ログアウト'
t.reset = 'リセット'
t.detail = '詳細'
t.editor = '編集'
t.success = '操作完了いたしました。'
t.submit = '確定'
t.import = '輸入' //
t.baoc = '保存'
t.submitOrder = '注文確定'

t.search = {
  search1: '運送状番号',
  search2: 'フィードバック番号',
  search3: '—',
  search4: 'タイプ',
  search5: '取引開始日', //
  search6: '取引終了日', //
  search7: 'オーダー番号',
  search8: 'オーダータイプ',
}

t.status = {
  status1: '処理待ち', //
  status2: '処理中', //
  status3: '終了した', //
  status4: 'キャンセル済み', //
  status5: '商品が届きませんでした', //
  status6: '製品がありません', //
  status7: '製品の損傷', //
  status8: '製品の欠陥', //
  status9: 'コストの問題', //
  status10: 'その他', //
  status11: '審查済み',
  status12: '審查不合格',
}

t.prompt = {}
t.prompt.title = 'ヒント'
t.prompt.info = '操作を続けますか[{handle}]?'
t.prompt.success = '操作完了'
t.prompt.failed = '操作は失敗しました'
t.prompt.deleteBatch = '削除する項目を選択して下さい'

t.validate = {}
t.validate.required = '必須項目を入力してください'
t.validate.format = '{attr}形式に誤りがあります'
t.validate.fileFormat = 'ファイルの形式に誤りがあります'

t.upload = {}
t.upload.text = '将文件拖到此处，或<em>点击上传</em>'
t.upload.tip = '只支持{format}格式文件！'
t.upload.button = 'アップロードをクリック'
t.upload.typeErr = 'サポートされていないファイル形式です。'

t.datePicker = {}
t.datePicker.range = '至'
t.datePicker.start = '開始日'
t.datePicker.end = '終了日'

t.fullscreen = {}
t.fullscreen.prompt = '您的浏览器不支持此操作'

t.updatePassword = {}
t.updatePassword.title = '修改密码'
t.updatePassword.username = '账号'
t.updatePassword.password = '原密码'
t.updatePassword.newPassword = '新密码'
t.updatePassword.comfirmPassword = '确认密码'
t.updatePassword.validate = {}
t.updatePassword.validate.comfirmPassword = '确认密码与新密码输入不一致'

t.contentTabs = {}
t.contentTabs.closeCurrent = '現在のタブを閉じる'
t.contentTabs.closeOther = '他のタブは閉じる'
t.contentTabs.closeAll = 'タブをすべて閉じる'

/* 页面 */
t.notFound = {}
t.notFound.desc = '抱歉！您访问的页面<em>失联</em>啦...'
t.notFound.back = '上一页'
t.notFound.home = 'TOP'

t.login = {}
t.login.title = 'ログインする'
t.login.username = 'ユーザー名：'
t.login.password = 'パスワード'
t.login.captcha = '認証コード'
t.login.demo = '在线演示'
t.login.copyright = '人人开源'

t.home = {}
t.home.sysInfo = {}
t.home.sysInfo.name = '系统名称'
t.home.sysInfo.nameVal = 'renren-security【企业版】'
t.home.sysInfo.version = '版本信息'
t.home.sysInfo.osName = '操作系统'
t.home.sysInfo.osVersion = '系统版本'
t.home.sysInfo.osArch = '系统架构'
t.home.sysInfo.processors = 'CPU核数'
t.home.sysInfo.totalPhysical = '系统内存'
t.home.sysInfo.freePhysical = '剩余内存'
t.home.sysInfo.memoryRate = '内存使用'
t.home.sysInfo.userLanguage = '系统语言'
t.home.sysInfo.jvmName = 'JVM信息'
t.home.sysInfo.javaVersion = 'JVM版本'
t.home.sysInfo.javaHome = 'JAVA_HOME'
t.home.sysInfo.userDir = '工作目录'
t.home.sysInfo.javaTotalMemory = 'JVM占用内存'
t.home.sysInfo.javaFreeMemory = 'JVM空闲内存'
t.home.sysInfo.javaMaxMemory = 'JVM最大内存'
t.home.sysInfo.userName = '当前用户'
t.home.sysInfo.systemCpuLoad = 'CPU负载'
t.home.sysInfo.userTimezone = '系统时区'

/* 模块 */
t.model = {}
t.model.name = '名称'
t.model.key = '标识'
t.model.version = '版本'
t.model.createTime = '作成日時'
t.model.lastUpdateTime = '更新时间'
t.model.design = '在线设计'
t.model.deploy = '部署'
t.model.description = '描述'

t.process = {}
t.process.name = '名称'
t.process.key = '标识'
t.process.deployFile = '部署流程文件'
t.process.id = '流程ID'
t.process.deploymentId = '部署ID'
t.process.version = '版本'
t.process.resourceName = 'XML'
t.process.diagramResourceName = '图片'
t.process.deploymentTime = '部署时间'
t.process.active = '激活'
t.process.suspend = '挂起'
t.process.convertToModel = '转换为模型'

t.running = {}
t.running.id = '实例ID'
t.running.definitionKey = '定义Key'
t.running.processDefinitionId = '定义ID'
t.running.processDefinitionName = '定义名称'
t.running.activityId = '当前环节'
t.running.suspended = '是否挂起'
t.running.suspended0 = 'NO'
t.running.suspended1 = 'YES'

t.news = {}
t.news.title = '标题'
t.news.pubDate = '发布时间'
t.news.createDate = '作成日時'
t.news.content = '内容'

t.schedule = {}
t.schedule.beanName = 'bean名称'
t.schedule.beanNameTips = 'spring bean名称, 如: testTask'
t.schedule.pauseBatch = '暂停'
t.schedule.resumeBatch = '恢复'
t.schedule.runBatch = '执行'
t.schedule.log = '日志列表'
t.schedule.params = '参数'
t.schedule.cronExpression = 'cron表达式'
t.schedule.cronExpressionTips = '如: 0 0 12 * * ?'
t.schedule.remark = '备注'
t.schedule.status = '状态'
t.schedule.status0 = '暂停'
t.schedule.status1 = '正常'
t.schedule.statusLog0 = '失败'
t.schedule.statusLog1 = '成功'
t.schedule.pause = '暂停'
t.schedule.resume = '恢复'
t.schedule.run = '执行'
t.schedule.jobId = '任务ID'
t.schedule.times = '耗时(单位: 毫秒)'
t.schedule.createDate = '执行时间'

t.mail = {}
t.mail.name = '名称'
t.mail.config = '邮件配置'
t.mail.subject = '主题'
t.mail.createDate = '作成日時'
t.mail.send = '发送邮件'
t.mail.content = '内容'
t.mail.smtp = 'SMTP'
t.mail.port = '端口号'
t.mail.username = '邮箱账号'
t.mail.password = '邮箱密码'
t.mail.mailTo = '受取人'
t.mail.mailCc = '抄送'
t.mail.params = '模板参数'
t.mail.paramsTips = '如：{"code": "123456"}'
t.mail.templateId = '模版ID'
t.mail.status = 'ステータス'
t.mail.status0 = '发送失败'
t.mail.status1 = '发送成功'
t.mail.mailFrom = '发送者'
t.mail.createDate = '发送时间'

t.sms = {}
t.sms.mobile = '手机号'
t.sms.status = '状态'
t.sms.status0 = '发送失败'
t.sms.status1 = '发送成功'
t.sms.config = '短信配置'
t.sms.send = '发送短信'
t.sms.platform = '平台类型'
t.sms.platform1 = '阿里云'
t.sms.platform2 = '腾讯云'
t.sms.params = '参数'
t.sms.paramsTips = '如：{"code": "123456"}'
t.sms.params1 = '参数1'
t.sms.params2 = '参数2'
t.sms.params3 = '参数3'
t.sms.params4 = '参数4'
t.sms.createDate = '发送时间'
t.sms.aliyunAccessKeyId = 'Key'
t.sms.aliyunAccessKeyIdTips = '阿里云AccessKeyId'
t.sms.aliyunAccessKeySecret = 'Secret'
t.sms.aliyunAccessKeySecretTips = '阿里云AccessKeySecret'
t.sms.aliyunSignName = '短信签名'
t.sms.aliyunTemplateCode = '短信模板'
t.sms.aliyunTemplateCodeTips = '短信模板CODE'
t.sms.qcloudAppId = 'AppId'
t.sms.qcloudAppIdTips = '腾讯云AppId'
t.sms.qcloudAppKey = 'AppKey'
t.sms.qcloudAppKeyTips = '腾讯云AppKey'
t.sms.qcloudSignName = '短信签名'
t.sms.qcloudTemplateId = '短信模板'
t.sms.qcloudTemplateIdTips = '短信模板ID'

t.oss = {}
t.oss.config = '云存储配置'
t.oss.upload = '上传文件'
t.oss.url = 'URL地址'
t.oss.createDate = '作成日時'
t.oss.type = '类型'
t.oss.type1 = '七牛'
t.oss.type2 = '阿里云'
t.oss.type3 = '腾讯云'
t.oss.type4 = 'FastDFS'
t.oss.type5 = '本地上传'
t.oss.qiniuDomain = '域名'
t.oss.qiniuDomainTips = '七牛绑定的域名'
t.oss.qiniuPrefix = '路径前缀'
t.oss.qiniuPrefixTips = '不设置默认为空'
t.oss.qiniuAccessKey = 'AccessKey'
t.oss.qiniuAccessKeyTips = '七牛AccessKey'
t.oss.qiniuSecretKey = 'SecretKey'
t.oss.qiniuSecretKeyTips = '七牛SecretKey'
t.oss.qiniuBucketName = '空间名'
t.oss.qiniuBucketNameTips = '七牛存储空间名'
t.oss.aliyunDomain = '域名'
t.oss.aliyunDomainTips = '阿里云绑定的域名，如：http://cdn.renren.io'
t.oss.aliyunPrefix = '路径前缀'
t.oss.aliyunPrefixTips = '不设置默认为空'
t.oss.aliyunEndPoint = 'EndPoint'
t.oss.aliyunEndPointTips = '阿里云EndPoint'
t.oss.aliyunAccessKeyId = 'AccessKeyId'
t.oss.aliyunAccessKeyIdTips = '阿里云AccessKeyId'
t.oss.aliyunAccessKeySecret = 'AccessKeySecret'
t.oss.aliyunAccessKeySecretTips = '阿里云AccessKeySecret'
t.oss.aliyunBucketName = 'BucketName'
t.oss.aliyunBucketNameTips = '阿里云BucketName'
t.oss.qcloudDomain = '域名'
t.oss.qcloudDomainTips = '腾讯云绑定的域名'
t.oss.qcloudPrefix = '路径前缀'
t.oss.qcloudPrefixTips = '不设置默认为空'
t.oss.qcloudAppId = 'AppId'
t.oss.qcloudAppIdTips = '腾讯云AppId'
t.oss.qcloudSecretId = 'SecretId'
t.oss.qcloudSecretIdTips = '腾讯云SecretId'
t.oss.qcloudSecretKey = 'SecretKey'
t.oss.qcloudSecretKeyTips = '腾讯云SecretKey'
t.oss.qcloudBucketName = 'BucketName'
t.oss.qcloudBucketNameTips = '腾讯云BucketName'
t.oss.qcloudRegion = '所属地区'
t.oss.qcloudRegionTips = '请选择'
t.oss.qcloudRegionBeijing1 = '北京一区（华北）'
t.oss.qcloudRegionBeijing = '北京'
t.oss.qcloudRegionShanghai = '上海（华东）'
t.oss.qcloudRegionGuangzhou = '广州（华南）'
t.oss.qcloudRegionChengdu = '成都（西南）'
t.oss.qcloudRegionChongqing = '重庆'
t.oss.qcloudRegionSingapore = '新加坡'
t.oss.qcloudRegionHongkong = '香港'
t.oss.qcloudRegionToronto = '多伦多'
t.oss.qcloudRegionFrankfurt = '法兰克福'
t.oss.localDomain = '域名'
t.oss.localDomainTips = '绑定的域名，如：http://cdn.renren.io'
t.oss.fastdfsDomain = '域名'
t.oss.fastdfsDomainTips = '绑定的域名，如：http://cdn.renren.io'
t.oss.localPrefix = '路径前缀'
t.oss.localPrefixTips = '不设置默认为空'
t.oss.localPath = '存储目录'
t.oss.localPathTips = '如：D:/upload'

t.dept = {}
t.dept.name = '名称'
t.dept.parentName = '上级部门'
t.dept.sort = '排序'
t.dept.parentNameDefault = '一级部门'

t.dict = {}
t.dict.dictName = '名称'
t.dict.dictType = '类型'
t.dict.dictValue = '值'
t.dict.sort = '排序'
t.dict.remark = '备注'
t.dict.createDate = '作成日時'

t.logError = {}
t.logError.requestUri = '请求URI'
t.logError.requestMethod = '请求方式'
t.logError.requestParams = '请求参数'
t.logError.ip = '操作IP'
t.logError.userAgent = '用户代理'
t.logError.createDate = '作成日時'
t.logError.errorInfo = '异常信息'

t.logLogin = {}
t.logLogin.creatorName = 'ユーザー名：'
t.logLogin.status = '状态'
t.logLogin.status0 = '失败'
t.logLogin.status1 = '成功'
t.logLogin.status2 = '账号已锁定'
t.logLogin.operation = '操作类型'
t.logLogin.operation0 = '登录'
t.logLogin.operation1 = '退出'
t.logLogin.ip = '操作IP'
t.logLogin.userAgent = 'User-Agent'
t.logLogin.createDate = '作成日時'

t.logOperation = {}
t.logOperation.status = '状态'
t.logOperation.status0 = '失败'
t.logOperation.status1 = '成功'
t.logOperation.creatorName = 'ユーザー名：'
t.logOperation.operation = '用户操作'
t.logOperation.requestUri = '请求URI'
t.logOperation.requestMethod = '请求方式'
t.logOperation.requestParams = '请求参数'
t.logOperation.requestTime = '请求时长'
t.logOperation.ip = '操作IP'
t.logOperation.userAgent = 'User-Agent'
t.logOperation.createDate = '作成日時'

t.menu = {}
t.menu.name = '名称'
t.menu.icon = '图标'
t.menu.type = '类型'
t.menu.type0 = '菜单'
t.menu.type1 = '按钮'
t.menu.sort = '排序'
t.menu.url = '路由'
t.menu.permissions = '授权标识'
t.menu.permissionsTips = '多个用逗号分隔，如：sys:menu:save,sys:menu:update'
t.menu.parentName = '上级菜单'
t.menu.parentNameDefault = '一级菜单'
t.menu.resource = '授权资源'
t.menu.resourceUrl = '资源URL'
t.menu.resourceMethod = '请求方式'
t.menu.resourceAddItem = '添加一项'

t.params = {}
t.params.paramCode = '编码'
t.params.paramValue = '值'
t.params.remark = '備考'

t.role = {}
t.role.name = '名称'
t.role.remark = '备注'
t.role.createDate = '作成日時'
t.role.menuList = '菜单授权'
t.role.deptList = '数据授权'

t.user = {}
t.user.username = 'ユーザー名：'
t.user.deptName = '所属部门'
t.user.email = '邮箱'
t.user.mobile = '手机号'
t.user.status = '状态'
t.user.status0 = '停用'
t.user.status1 = '正常'
t.user.createDate = '作成日時'
t.user.password = '密码'
t.user.comfirmPassword = '确认密码'
t.user.realName = '真实姓名'
t.user.gender = '性别'
t.user.gender0 = '男'
t.user.gender1 = '女'
t.user.gender2 = '保密'
t.user.roleIdList = '角色配置'
t.user.validate = {}
t.user.validate.comfirmPassword = '确认密码与密码输入不一致'

t.home = {
  list1: `『中華人民共和国海事法』に依拠する;
  「税関総署の新速達通関システムの稼働に関する公告」(税関総署の公告2016年第19号)などの法規は、受取人が身分証明書のコピーを提供し、用途を証明し、個人物品類の入出国速達の通関手続きを行うことを要求している。
  提供できない場合は、承諾書を作成する必要があります。受取人が身分証明書の表裏コピーまたは承諾書の提供を拒否した場合、小包は通関できません。税関は返送処理を行います。
  これによる損失については一切責任を負いません。みなさんご協力をお願いします`,
  list2: `パケ梱包ルール

  1.単一の小包の価格は税関の許可範囲内です。

  2.総数量10箇以内、申告商品数量6種類内(同じバーコード6件内)、1.6キロを超えない!

  3.食品、健康食品、母子用品、化粧品及びその他の雑貨(同じバーコード6件内)、粉ミルク2缶1箇の小包(その他の物品を入れてはいけない)

  4.大人服6着、子供服8着、下着10着内(同梱されていないもの)

  5.ケース別梱包。

  6.靴単体梱包(子供用は2足まで)

  7.家電およびリチウム電池を含まないデジタル制品、アクセサリ、時計を別個に梱包する。

  8. avディスク類(5ディスク内、セットは1セット限り、avディスクのみ配布の場合、最大10件または3セットまで)

  9.時効3 ~ 7日

  10 .を探し出す、処方し、ぜいたく品、宝石、真珠、珊瑚などの贵重なアクセサリー類(、シャネル、エルメス、ルイヴィトン、guccl、カルティエ、ディオール、ポロ、巴宝莉、プラダ、プラダ、フィリピン・アルハクソン、ジバンシー、ロレックス、パテックフィリップ、バセロン・コンスタンチン、伯爵、オメガ、積家、万国、ブレゲ、ショパン、方海と朗格、彼を爱してなどすべての贅沢品は郵送禁止)。「明治」「グリコ」の字の乳幼児用粉ミルクの産地は日本の栃木、埼玉などの放射能地域で、立ち入り禁止貨物に属している。2011年に日本の福島原発事故が発生した後、中国はすでに禁止令を発令して日本の放射能地域(福島、群馬、栃木、茨城、宮城、新潟、長野、埼玉、東京、千叶などの地域)の食品を中国に入ることを禁止して、この禁止令は今まで依然として有効です。日本の乳幼児の粉ミルクのブランド、明和、森永、雪印、光堂、グリコ、その他の生産は放射能の区域に入ることを禁止して、自分で調べてください。放射能の地域からの食品を発見して、この小包は焼却処理を行って、郵送してはいけなくて、私的に持参することを厳禁して、もたらした結果の損失は自分で負担します!

  11。単一分割することができない物品(単独で梱包)は、実際の価格に基づいて税金を支払う。

  *商品数量制限は税関の要求により随時調整される可能性がありますので、実際にはこのページの最新公示に準じます!

  **航空又は貨物輸送規定の危険物;運送、輸出入が経由国を含む輸出入国、州、地方自治体の法令により禁止又は制限される物品。航空、運送会社の運送協議で許可されていないその他の物品;当社が規定に適合しないと判断したその他の物品。

  上記の物品では当社の通関サービスはご利用できません。当社は、商品の内容を開封して検査する権利があり、検査を行う際に法律法規に違反する可能性がある商品がある場合、当社は警察及び関連法執行部門に報告し、商品を提出するなどの措置をとることができる。商品の検査及び本条に規定された処理方法を采取して会員に損害を与えた場合、当社は一切の責任を負いません。当社は商品を開封して検査し、本規定に合致しない商品及び禁制品を発見したら、直ちにサービスを停止し、直ちに廃棄又はその他の方法で処分することができます。通関商品は出入国国の法律法規およびその他の利害関系者の要求に合致しなければならず、法律または特定の要求に違反した商品については、当社はいつでもサービスを停止することができ、いかなる責任も負いません。`,
  list3: `*禁制品は禁制品

  1入境禁止品

  1.1様々な武器、模擬武器、弾薬および爆発物;

  偽造貨幣及び偽造有価証券。

  1.3中国の政治、経済、文化、道徳に有害な印刷物、フィルム、写真、レコード、映画、テープ、ビデオテープ、レーザーディスク、コンピュータ記憶媒体およびその他の物品;

  1.4各種の強力な毒薬;

  1.5アヘン、モルヒネ、ヘロイン、マリファナ、および他の依存性麻酔、向精神薬;

  1.6危険性のある病原菌、害虫、その他の有害生物を有する働物、植物およびその制品;

  1.7チーム人畜の健康や感染地域からの、他のが感染疾患の食品や医薬品や他の品;

  1.8の為の対策や法律、税関の进境の他の品物を禁止した。

  2入境物品を制限する

  2.1無線送受信機、通信秘密保持機;

  2.2タバコ、酒;宝石、真珠、珊瑚などの貴重なアクセサリー類。

  2.3絶滅の恐れがあり、貴重な働物、植物(標本を含む)、および繁殖材料の種;

  2.4国の通貨;

  2.5税関制限进境の他の品。

  3禁輸品

  3.1各種武器、弾薬。例えば铳、弾丸、砲弾、手榴弾、地雷、爆弾など;

  3.2爆発性のある物の種類。例えば雷管、爆薬、火薬、爆竹など;

  3.3各種燃えやすい性物品は、液体、気体と固体。ガソリンと灯油、桐油、アルコール、生漆、軽油、气雾剂、ガスのライター、ガスのガスボンベ、リン、硫黄、マッチなど、

  3.4各腐蚀性物変わりやすい。火硫酸、塩酸、硝酸、有机溶剤、農薬、過酸化水素、危険な化学品など;

  3.5様々な種類の放射性元素と容器。ウラン、コバルト、ラジウム、プルトニウムなど。

  3.6あらゆる種類の劇薬。タリウム、シアン化物、ヒ素など。

  3.7麻酔薬のすべての種類。アヘン(ケシの殻、花、つぼみ、叶を含む)、モルヒネ、コカイン、ヘロイン、大麻、シャブ、エフェドリンおよびその他の制品など;

  3.8様々な化学製品と伝染物品。例えば炭疽や危険ウイルス、医薬用の廃棄物など;

  3.9各種国家安全の危害社会政治の安定やわいせつの出版物と物、印刷物など;

  3.10公衆衛生を害する各種物品。例えば死体の骨、働物の器官、肢体、硝子制の獣皮、薬制の獣骨などを経ていない;

  3.11国の法律、法規、行政規則は、国の秘密文書や資料、国の通貨や偽造された通貨や有価証券など、流通、郵送、または入出国を禁止する物品を明示している。

  3.12不適切な包装、汚染、または他の郵便物、設備の物品を損傷する可能性があります。

  3.13各寄達国(地域)は輸入品などを送ることを禁止します;

  3.14その他差し出すことが禁止されているもの。

  一、动物や製品の类

  (1)活働物(犬、猫を除く【2】)で、哺乳働物、鳥類、魚類、両生類、爬虫類、昆虫類、その他の無脊椎働物のすべて。働物の遺伝物質。

  (2)(生または熟した)肉類(臓器を含む)とその制品;水生動物の産物です

  (三)生乳、生乳、ヨーグルト、働物由来のクリーム、バター、チーズなどの乳制品を含む働物由来乳および乳制品。

  (四)卵とその制品、新鮮な卵、皮の卵、塩漬けの卵、卵液、卵の殻、マヨネーズなどの卵ソース制品を含む。

  (五)ツバメの巣(缶詰入りのツバメの巣を除く)。

  (六)油脂類、皮張、毛類、蹄、骨、歯、角類及びその制品。

  (七)働物由来飼料(肉粉、骨粉、魚粉、乳清粉、血粉などの単一飼料)、働物由来漢方薬、働物由来肥料を含む。

  二、植物及び植物制品類

  (八)新鮮な果物、野菜。

  (九)たばこの叶(糸を含まない。)

  (10)種子(苗)、苗木、その他繁殖能力を有する植物材料。

  (11)有機栽培媒体。

  その3その他のカテゴリー

  (十二)菌種、毒種等の働植物の病原体、害虫及びその他の有害生物、細胞、器官組織、血液及びその制品等の生物材料。

  (十三)動物の死体、動物標本、動物由来廃棄物。

  (14)土壌

  (15)遺伝子組み換え生物材料。

  (十六)国が立ち入りを禁止するその他の働植物、働植物産品その他の検疫物。`,
  list4: `国内速達の輸送の過程で制御することができない原因のため、私達は輸送の過程で速達の破損による損失を弁償することができなくて、損をしやすい物品に対して必ず補強して処理してください。

  ように貨物を失って、紛失小包の受注の提供、国際輸送単号、紛失小包ですべての商品のショッピングサイトの受注がハードコピー(ショッピングや小さな)(スクリーンショット/メモリなければ商品明細を具現できる具体的な破損、購買価値、モノの住所と宅配単号などの重要情報)、商品別の実質価値/ユーザー申告両者は少ない金額を鉄の、最高賠償金額は1500元(申告価値と商品数量はユーザーでコード入力システムを掃引して准備して、もし疑問があるならば顧客サービスに連絡して修正してください)。`,
  list5: `親愛なるお客様

  こんにちは

  山東省の防疫政策の要求に基づき、4月10日から空港の輸入貨物を集中的に管理する倉庫が稼働し、貨物が到着した後に

  10日間放置しておく

  商品の消毒とサンプル検査を行う。

  この政策は最大限に受け取りの安全を保証して、各位の取引先に服装の糸と雑貨の普通の糸を持ってきて、物流の時効が延長することをお愿いします!

  政策関連の公式文書を必要とすれば、顧客サービスに連絡して発送することができる。`,
  home1: '金メダルエージェント',
  home2: '資金残高',
  home3: 'チャージ',
  home4: 'プロセスの使用',
  home5: '小包を日倉に発送する',
  home6: '顧客提出運送状',
  home7: '日倉サイン/パッケージング/重量測定',
  home8: '顧客が運賃を支払う',
  home9: '国際輸送、通関',
  home10: '中国国内配送',
  home11: 'メールボックス検証',
  home12: '小包を受け取る',
  home13: 'ビジネス統計',
  home14: '重要なお知らせ',
  home15: '支払保留中の運送状',
  home16: '運送伝票番号',
  home17: '金額（元）',
  home18: '支給',
  home19: 'すべての運送状',
  home20: '支払保留中の運送状',
  home21: '例外運送状',
  home22: '入荷/出荷人数',
  home23: 'アフターサービスフィードバック',
  home24: '受取人の身分証明書の表裏の通知を提供する',
  home25: '梱包ルールの明細',
  home26: '禁制品発禁リスト',
  home27: '禁制品発禁リスト',
  home28: '通関についてのお知らせ',
}

t.wzbg = {
  wz1: '作成開始日',
  wz2: '作成終了日',
  wz3: '小包番号',
  wz4: 'リセット',
  wz5: 'ステータス',
  wz6: 'No.',
  wz7: '物流会社',
  wz8: '日本物流単号',
  wz9: '時間を引き取る',
  wz10: 'バイト',
  wz11: '運送伝票を作成する',
  wz12: '小包受け取り',
  wz13: 'キャンセル',
  wz14: '确かに定',
  wz15: '日本国内の追跡番号を入力してください',
  wz16: '認証待ち',
  wz17: '認知済み',
  wz18: 'キャンセル完了',
  wz19: 'すべて',
}
t.menu = {
  menu1: '情報管理',
  menu2: 'すべての商品',
  menu3: '商品の新規作成',
  menu4: '商品を編集する',
  menu5: '商品の詳細',
  menu6: '入出荷先管理',
  menu7: 'アカウント管理',
  menu8: '個人情報の設定',
  menu9: 'アカウントの設定',
  menu10: 'アカウントセキュリティ-メールアカウントを変更する',
  menu11: 'アカウントセキュリティ-ログインパスワードを変更する',
  menu12: '財務管理',
  menu13: '資金記録明細',
  menu14: 'アカウントチャージ',
  menu15: '輸送状管理',
  menu16: '輸送状リスト',
  menu17: '輸送状の新規作成',
  menu18: '無主小包',
  menu19: '輸送状詳細',
  menu20: '請求書の詳細',
  menu21: '異常品',
  menu22: '異常品の詳細',
  menu23: 'アフターサービスフィードバック',
  menu24: '編集フィードバック',
  menu25: 'フィードバックの詳細',
}

t.goods = {
  goods1: '商品番号',
  goods2: '商品名',
  goods3: '審査待ち',
  goods4: '審査済み',
  goods5: '却下された',
  goods6: '商品税関分類',
  goods7: '商品の中国語名',
  goods8: '仕様',
  goods9: '商品単価',
  goods10: '単位',
  goods11: '産地',
  goods12: 'この商品を承認しますか？',
  goods13: '駮に',
  goods14: '同じ意味',
  goods15: '審査に成功する',
  goods16: '商品コードを入力して、システム内にこの商品の情報が存在するか確認してください。',
  goods17: '商品バーコード',
  goods18: '必須情報',
  goods20: 'メインイメージ',
  goods21: '選んでください',
  goods22: '商品の英語名',
  goods23: 'ブランド名（中国語）',
  goods24: '品名(中国語)',
  goods25: '仕様',
  goods26: 'ネットウェート',
  goods27: '原産国単価',
  goods28: 'その他',
  goods29: '原産国商品名',
  goods30: '原産国ブランド名',
  goods31: 'ブランド名（英語）',
  goods32: '商品名（英語）',
  goods33: '人民元単価。',
  goods34: '原産国価格  EXP:日本円、ドルなど',
  goods35: 'マスク数',
  goods36: '申告数量',
  goods37: '通貨種類',
  goods38: '通貨を選んでください',
  goods39: '商品税',
  goods40: '詳細情報',
  goods41: '中国税関HS CODE税番号',
  goods42: '計量単位',
  goods43: '原産国',
  goods44: '原産国税関HS CODE',
  goods45: '工場コード',
  goods46: '成分',
  goods47: '商品サイト',
  goods48: '備考',
  goods49:
    'システムの中ですでに審査したこの条規の商品が存在して、重複して添加しないでください!',
  goods50: 'システムに保存されています',
  goods51: '商品のコードを確認します。',
  goods52: '審査して確認する',
  goods53: '承認済み',
  goods54: ['ドル', '円', 'ユーロ', 'カナダドル', 'ドル', '香港ドル', 'ウォン'],
}

t.loginR = {
  login1: 'パスワードを忘れた場合',
  login2: 'アカウントがありません。今すぐ',
  login3: 'アクティベーション成功',
  login4: 'アカウントの登録が完了しました。ログインして下さい',
  login8: '今すぐ新規登録する',
  login9: 'メールアドレスを入力してください',
  login10: 'パスワードを確認する',
  login11:
    '登録すると、「ユーザーサービスプロトコル」および「プライバシーポリシー」に同意したことになります。',
  login12: 'ログインページへ',
  login13: '送信完了。',
  login14:
    'アクティベーションメールを送信しました。メールを確認し、指示に従ってアカウントをアクティベートしてください。',
  login15: 'ログインページへ',
  login16: 'パスワードを入力してください',
  login17: 'もう一度パスワードを入力してください',
  login18: '2回入力されたパスワードが一致しません',
  login19: '登録するには利用規約に同意する必要があります。',
  login20: '正しいメールアドレスを入力してください',
  login21: 'パスワードは6〜20文字で入力してください',
  login22: 'メールアドレス検証',
  login23: '身分证明',
  login24: '流れの説明',
  login25: '完了',
  login26: '次へ',
  login27: 'メールアドレス認証コード',
  login28: '新しいパスワードの設定が完了しました',
  login29: '下のボタンをクリックするか、',
  login30: '今すぐにログインする',
  login31: '再送する',
  login32: '送信',
  login33: '秒',
  login34: '重発',
  login35: '秒後に自動的に戻ります',
  login36: '6〜20桁のログイン名を入力してください',
  login37: '氏名を入力してください',
  login38: '最大50文字まで入力可能です',
}

t.feedback = {
  feedback1: 'フィードバックの送信',
  feedback2: '質問タイプ',
  feedback3: '作成時間',
  feedback4: 'このフィードバックをキャンセルしますか?', //
  feedback5: 'フィードバック内容を選択してください', //
  feedback6: '運送状番号を入力してください', //
  feedback7: '問題の説明',
  feedback8:
    '問題を説明してください。できるだけ早くご連絡します。', //
  feedback9: '画像',
  feedback10: '認証コード',
  feedback11: '正しい認証コードを入力してください',
  feedback12: '質問タイプを選択してください', //
  feedback13: '運送状番号を入力してください', //
  feedback14: '問題の説明を入力してください', //
  feedback15: '認証コードが間違っています', //
  feedback16: '現在の進行状況',
  feedback17: '処理説明', //
  feedback18: 'リストに戻る', //
  feedback19: '協議の結果、補償させて頂くことを決定しました', //
  feedback20: '処理説明の記入', //
  feedback21:
    '箱詰め申請を修正する必要がある場合はカスタマーサービスに連絡してください。', //
}

t.address = {
  address1: 'お客様', //
  address2: '顧客名', //
  address3: 'アドレスキーワード', //
  address4: '電話番号',
  address5: '身分証明書番号',
  address6: 'デフォルトにする',
  address7: 'デフォルト積荷', //
  address8: 'デフォルト受取人', //
  address9: '住所',
  address10: 'エリア',
  address11: '受取人',
  address12: '出荷元',
  address13: '受取+出荷者',
  address14: 'アドレスの編集', //
  address15: '住所追加',
  address16: 'アドレスの詳細', //
  address17: '本当にこの住所を削除しますか？', //
  address18: '出荷先所在地', //
  address19: '名前',
  address20: '郵便番号',
  address21: 'メールアドレス',
  address22: '国家', //
  address23: '国を選択してください', //
  address24: '地域を選択してください', //
  address25: '詳細住所',
  address26: '詳細住所、町、番地など',
  address27: '身分証明書の表',
  address28: '身分証明書の裏',
  address29:
    'アップロード画像のサイズは600 px*600 pxであることをお勧めします。正確にアップロードしてください。',
  address30: '受取/出荷者',
  address31: 'デフォルトの受取人を設定',
  address32: 'デフォルト出荷元を設定',
  address33: '証明書番号を入力してください', //
  address34: '電話番号を入力してください', //
  address35: '郵便番号を入力してください', //
  address36: '国を選択してください', //
  address37: '詳細な住所を入力してください', //
  address38: '選択して下さい。',
  address39: '名前を入力してください', //
  address40: 'メールアドレスを入力してください', //
  address41: 'コメントを入力してください', //
  address42: 'テンプレートのダウンロード', //
  address43: 'ブラウズ',
}

t.excel = {
  excel1: 'テンプレートのダウンロード',
  excel2: '浏览',
  excel3: 'xlsファイルをアップロードしてください',
  excel4: '有料項目',
  excel5: '価格(元)',
  excel6: '価格',
  excel7: '数量',
  excel8: '支払額',
  excel9: '未提出',
  excel10: '承認済み',
  excel11: '承認失敗',
  excel12: 'マニュアル',
  excel13: '料金表',
  excel14: '詳細検品指示書',
}

t.photo = {
  photo1: '画像のアップロードはjpg、jpeg、png形式のみ対応しています！', // #
  photo2: '5MB未満の画像をアップロードしてください', // #
}
t.accountInformation = {
  accountInformation1: 'ユーザーID',
  accountInformation2: '会社名：',
  accountInformation3: '10文字以内で入力してください', //
  accountInformation4: '20文字以内で入力してください', //
  accountInformation5: '会社/店舗名を入力してください', //
  accountInformation6: '住所：',
  accountInformation7: '国際送料自動控除設定：',
  accountInformation8: 'オープン', //
  accountInformation9: '閉じる', //
  accountInformation10: '名前は最大10文字',
  accountInformation11: '会社名は最大20文字',
}

t.cs = cs

t.changeAccount = {
  changeAccount1: '現在のアカウントは',
  changeAccount2: '登録メ-ルアドレス',
  changeAccount3: '現在の登録メ-ルアドレス',
  changeAccount4:
    'メールアドレスが失われたり無効になった場合は、すぐに変更してください', //
  changeAccount5: '旧メールアドレスを交換してください',
  changeAccount6: 'ログインパスワード',
  changeAccount7:
    '定期的にパスワードを変更することをお勧めします。アカウントの安全性が向上します。',
  changeAccount8: 'パスワードの変更',
  changeAccount9: 'メールアドレスを交新してください',
  changeAccount10: '身份認証',
  changeAccount11: 'メールアドレスを交新してください',
  changeAccount12: '完了',
  changeAccount13: '認証コードを入力してください',
  changeAccount14: '認証コードの取得',
  changeAccount15: '正しい認証コードを入力してください',
  changeAccount16: '認証コード送信成功', //
  changeAccount17: '次へ',
  changeAccount18: '新しいメールアドレスを入力してください',
  changeAccount19: '正しいメールアドレス形式を入力', //
  changeAccount20: '戻る',
  changeAccount21: 'メールアドレスの変更が完了しました。',
  changeAccount22: '下のボタンまたは',
  changeAccount23: '秒後に戻ります',
  changeAccount24: '新しいパスワード設定が完了しました',
  changeAccount25: 'xlsファイルをアップロードしてください', //
  changeAccount26: 'ログインパスワードの変更', //
  changeAccount27: '6〜16桁の新しいログインパスワードを設定してください',
  changeAccount28: '6〜16桁の新しいログインパスワードを確認してください',
  changeAccount29: 'パスワードを入力してください', //
  changeAccount30: '2回入力したパスワードを一致させてください。',
  changeAccount31: '長さは6～20文字', //
  changeAccount32: '電話番号の登録',
  changeAccount33:
    '携帯電話番号が無効になった場合はすぐに変更して下さい',
  changeAccount34: '電話番号を変更する',
  changeAccount35: 'ログインメールアドレスの変更',
  changeAccount36: '秒',
  changeAccount37: '再送する',
  changeAccount38: '新しいメールアドレスを入力してください',
  changeAccount39: 'メールアドレスの変更が完了しました',
  changeAccount40: 'ヒント',
  changeAccount41:
    'アカウントのセキュリティを確保するために、重要な情報を変更するには認証が必要です',
  changeAccount42: 'お問い合わせはお問い合わせメッセージよりご連絡下さい',
  changeAccount43: 'メールアドレスは既に登録されております。',
  changeAccount44: '確認コードを送信する',
  changeAccount45: '電話番号の変更',
  changeAccount46: '変更したい電話番号を入力してください',
  changeAccount47: '電話番号を空欄にすることはできません',
  changeAccount48: '電話番号の形式が正しくありません',
  changeAccount49: '登録済みの電話番号と同じにすることはできません',
  changeAccount50: '新しい電話番号が正常に設定されました',
  changeAccount51: '6桁の大文字と小文字、数字の2種類を入力してください',
  changeAccount52:
    '新しいログインパスワードが正常に設定されました。もう一度ログインしてください',
  changeAccount53: '下のボタンをクリックしてください',
  changeAccount54: 'また',
  changeAccount55: '秒後に自動的に戻ります',
}

t.capitalflow = {
  capitalflow1: 'オーダー金額(円)',
  capitalflow2: 'オーダー時間',
  capitalflow3: '取引先',
  capitalflow4: '使用可能残高(円)',
  capitalflow5: 'チャージ',
  capitalflow6: '返金（現金引き出し）', //
  capitalflow7: '運送状支払', //
  capitalflow8: '運送状入金', //
  capitalflow9: '物流支払', //
  capitalflow10: '物流入金', //
  capitalflow11: '引き落とし', //
  capitalflow12: 'に報いる', //
  capitalflow13: '返金', //
  capitalflow14: 'サービス料', //
  capitalflow15: 'チャージ手数料', //
}

t.createOrder = {
  createOrder1: '受注の作成', //
  createOrder2: '各種預かり品',
  createOrder3: '紙タグ',
  createOrder4: '洗濯タグ',
  createOrder5: '襟タグ',
  createOrder6: '商品付属品',
  createOrder7: '残高',
  createOrder8: 'チャージ',
  createOrder9: '一括アップロード',
  createOrder10: '操作',
  createOrder11: '国内運送状番号',
  createOrder12: '【淘宝/1688】商品リンク',
  createOrder13: '商品情報',
  createOrder14: '名前：',
  createOrder15: '数量：',
  createOrder16: '単価：',
  createOrder17: '色：',
  createOrder18: 'サイズ：',
  createOrder19: 'SKU：',
  createOrder20: 'アップロード',
  createOrder21: '購入代行',
  createOrder22: 'PDF/AIファイル',
  createOrder23: 'FBA/YFF/ZOZO/RSL/ストッククルー',
  createOrder24: 'FNSKU',
  createOrder25: '検品オプション',
  createOrder26: '洗濯タグテンプレート',
  createOrder27: '包装意向',
  createOrder28: '輸入責任者住所',
  createOrder29: '名前：',
  createOrder30: '電話番号：',
  createOrder31: '住所：',
  createOrder32: '選択',
  createOrder33: '編集',
  createOrder34: '配送先住所',
  createOrder35: '郵便番号：',
  createOrder36: '一行増加',
  createOrder37: '価格：',
  createOrder38: '数量：',
  createOrder39: 'デフォルト住所',
  createOrder40: '電話番号',
  createOrder41: '県/市／区を選択',
  createOrder42: '郵便番号',
  createOrder43: '住所をデフォルトにしますか？',
  createOrder44: '正しい電話番号を入力して下さい', //
  createOrder45: '商品名を記入してください', //
  createOrder46: '商品規格を記入してください', //
  createOrder47: '数量を記入してください', //
  createOrder48: '0より大きい整数を入力してください', //
  createOrder49: '正しい金額形式を入力してください', //
  createOrder50: 'コメントを記入してください', //
  createOrder51: '省を選択', //
  createOrder52: '市', //
  createOrder53: '区/街道', //
  createOrder54: '名前を記入してください', //
  createOrder55: '電話番号を記入してください', //
  createOrder56: '詳細な住所を記入してください', //
  createOrder57: '郵便番号を記入してください', //
  createOrder58: '袋詰め',
  createOrder59: 'ダンボール箱',
  createOrder60: '靴箱',
  createOrder61: '特殊箱',
  createOrder62: '運送状番号を入力してください', //
  createOrder63: '正しい形式の運送状番号を入力してください', //
  createOrder64: '住所を選択してください', //
  createOrder65: '送信者を選択してください', //
  createOrder66: '受信者を選択してください', //
  createOrder67: '住所選択', //
  createOrder68: 'ファイルを削除しますか？', //
  createOrder69: '削除されました', //
  createOrder70: '削除をキャンセルしました', //
  createOrder71: '画像を削除しますか？', //
  createOrder72: 'アップロードファイルはPDF形式のみ対応しています！', //
  createOrder73: 'アップロード成功', //
  createOrder74: 'jpg、jpeg、png形式の画像をアップロードしてください！', //
  createOrder75: 'アップロード失敗', //
  createOrder76:
    'すべての画像のアップロードを待つかページを再読み込み後に再度アップロードしてください！', //
  createOrder77: '最大で1枚の画像をアップロードできます', //
  createOrder78: 'このオーダー情報を削除しますか？', //
  createOrder79: 'データを最低1つ保持してください', //
  createOrder80: '数量を入力してください。', //
  createOrder81: '色を入力してください', //
  createOrder82: '単価を入力してください。', //
  createOrder83: '正しい形式の運送状番号を入力してください', //
  createOrder84: '入力してください', //
  createOrder85: '名前を入力してください', //
  createOrder86: '住所を入力してください', //
  createOrder87: '洗濯タグテンプレートを選択してください', //
  createOrder88: '緑', //
  createOrder89: '赤', //
  createOrder90: '運送状番号が長すぎます', //
  createOrder91: '現在は1ファイルしか選択できません', //
  createOrder92: '今回選択したファイル', //
  createOrder93: '個ファイル', //
  createOrder94: '選択しました', //
  createOrder95: '詳細検品指示書',
  createOrder96:
    'アップロードできるファイルは、doc、docx、xls、xlsx、ppt、pptx、pdf、txt、jpg、jpeg、png、gif 形式のみです',
  createOrder97:
    'アップロード ファイルのサイズは 20 MB を超えることはできません',
  createOrder98: 'アップロードできるファイルは、pdf、ai 形式のみです',
  createOrder99: 'オーダー属性',
  createOrder100: 'FBA/YFF/ZOZO/RSL/ストッククルー',
  createOrder101: 'お問い合わせ',
  createOrder102: 'ユーザID',
  createOrder103: 'メッセージ・タイプ',
  createOrder104: 'オーダー番号',
  createOrder105: 'タイトル',
  createOrder106: '内容',
  createOrder107: '画像',
  createOrder108: 'アップロードファイルのサイズは20MB以下である必要があります',
  createOrder109: '内容を記入してください',
  createOrder110: 'その他のタイプ',
  createOrder111: '備考欄',
  createOrder112: '中国運輸',
  createOrder113: '品名：',
  createOrder114: 'fnsku 品名を入力してください',
  createOrder115: '中国運賃を入力してください',
  createOrder116: '商品名：',
  createOrder117: '添付ファイルのアップロード',
  createOrder118: '最大9ファイルを選択できます',
  createOrder119: '最大３ファイルを選択できます',
  batchDelete: '一括削除',
  confirmDelete: '削除を確認しますか？',
  specialChar:
    'ファイル名に以下の文字を含めることはできません：，；：｛｝* ファイル名を修正してから再アップロードしてください。',
  createOrder120: 'No',
  createOrder121: 'オーダー番号',
  createOrder122: '商品SKU：',
  createOrder125: '色とサイズを選択してください',
}

t.orderList = {
  orderList1: '注文リスト', //
  orderList2: 'オーダー番号', //
  orderList3: '内容を入力してください',
  orderList4: '国際運送状番号',
  orderList5: '国内運送状番号',
  orderList6: '購入待ち',
  orderList7: '購入完了',
  orderList8: '入庫待ち',
  orderList9: '到着済',
  orderList10: '倉庫保管中',
  orderList11: '支払い待ち',
  orderList12: '不具合注文',
  orderList13: '完了',
  orderList14: '商品コピー',
  orderList15: '並べ替え',
  orderList16: '返品',
  orderList17: '返品の取消', //
  orderList18: '破棄',
  orderList19: '破棄の取り消し',
  orderList20: '商品分割',
  orderList21: '送料明細',
  orderList22: '支払い',
  orderList23: 'お問い合わせ',
  orderList24: '不具合注文',
  orderList25: '国内運送状番号を入力してください', //
  orderList26: '色',
  orderList27: 'サイズ',
  orderList28: '商品SKU',
  orderList29: '商品数量',
  orderList30: '梱包待ち数',
  orderList31: '返品数量',
  orderList32: '破棄数量',
  orderList33: '出荷申請',
  orderList34: '問題商品',
  orderList35: '再発送中',
  orderList36: '交換中',
  orderList37: '受注情報', //
  orderList38: '元発注番号',
  orderList39: '元受注ステータス',
  orderList40: '元注文数量',
  orderList41: '元注文返品数',
  orderList42: '元注文破棄数',
  orderList43: '元注文はFBA？',
  orderList44: '元注文倉庫保管',
  orderList45: '請求情報', //
  orderList46: '注文ステータス',
  orderList47: '倉庫保管',
  orderList48: '返品数',
  orderList49: '破棄数量',
  orderList50: 'メッセージタイプ：',
  orderList51: '注文メッセージ', //
  orderList52: 'オーダー番号：',
  orderList53: 'タイトル：',
  orderList54: '内容：',
  orderList55: '画像：',
  orderList56: '数量は0より大きく、元の数量以下である必要があります。',
  orderList57: '数量を入力してください', //
  orderList58: '返品数は0以上、元の返品数以下である必要があります', //
  orderList59: '返品数を入力してください', //
  orderList60: '返品数は0以上、元の返品数以下である必要があります', //
  orderList61: '破棄数を入力してください', //
  orderList62: 'タイトルを入力してください',
  orderList63: '返信内容を入力してください',
  orderList64: '到着',
  orderList65: '検品中',
  orderList66: '検品完了',
  orderList67: '不良品交換却下', //
  orderList68: '交換品返送待ち', //
  orderList69: '交換して到着を待つ', //
  orderList70: '一部商品返品待ち', //
  orderList71: '再発行して到着を待つ', //
  orderList72: '発送待ち',
  orderList73: '発送済み',
  orderList74: '返品申請中', //
  orderList75: '返金待ち', //
  orderList76: '返品待ち', //
  orderList77: '返品済', //
  orderList78: '廃棄申請中', //
  orderList79: '廃棄支払い待ち', //
  orderList80: '一部商品廃棄待ち', //
  orderList81: '廃棄済み', //
  orderList82: 'パッキン中',
  orderList83: '保存完了', //
  orderList84: '保存に失敗しました', //
  orderList85: 'コピーするオーダーを選択してください',
  orderList86:
    '返品申請のキャンセルを確認しますか？キャンセルすると、注文は返品申請時の状態に戻ります。',
  orderList87: '返品キャンセルいたしました。',
  orderList88:
    '返品を申請しますか？返品には手数料が発生する場合があります。',
  orderList89: '破棄すると手数料が発生する場合あります。破棄しますか？', //
  orderList90: '破棄すると手数料が発生する場合あります。破棄しますか？', //
  orderList91: '破棄完了', //
  orderList92: '破棄が取り消されました',
  orderList93:
    'この注文の破棄をキャンセルしますか？キャンセルすると、注文は破棄申請時の状態に戻ります。',
  orderList94: 'この注文を倉庫保管注文として設定しますか？',
  orderList95: '倉庫保管完了', //
  orderList96: '倉庫保管がキャンセルされました', //
  orderList97: '出荷を申請しますか？',
  orderList98: '発送申請',
  orderList99: '出荷申請が完了しました',
  orderList100: '出荷申請をキャンセルしました',
  orderList101: '注文をキャンセルしますか？',
  orderList102: '注文の取消', //
  orderList103: 'キャンセル済みの注文', //
  orderList104: '必須項目は空白にできません。再度入力の上提出してください！', //
  orderList105:
    '全ての画像がアップロードされるのを待つかページを再読み込みし再度アップロードをお試し下さい！', //
  orderList106: '最大で1枚の画像をアップロードできます', //
  orderList107: '削除を確認しますか？', //
  orderList108: 'パッケージ済み', //
  orderList109: '購入不可', //
  orderList110:
    '返品には返品手数料がかかる場合があります。返品を申請しますか？', //
  orderList111: '廃棄待ち',
  orderList112: '運送状のステータス',
  orderList113: 'すべて',
  orderList114: '到着',
  orderList115: '検品中',
  orderList116: '発送待ち',
  orderList117: 'パッキン中',
  orderList118: '単価',
  orderList119: '中国運賃',
  orderList120: '総額',
  orderList121: '元',
  orderList122: 'ダウンロード',
  orderList123: '再計算',
  orderList124: 'コスト計算',
  orderList125: '少なくとも 1 つの注文を選択してください',
  orderList126: '発送待ち',
  orderList127: '到着',
  orderList128: '検品完了',
  orderList129: '箱詰め申請可能',
  orderList130: '実重量',
  orderList131: '合計',
  orderList132: '件の注文を選択しました.再計算しますか？',
  orderList133:
    '選択された注文がない場合、現在リストにあるすべての注文の費用が計算されます。合計',
  orderList134: '件、計算には時間がかかることがあります。実行しますか？',
  orderList135: 'オーダー数量',
  orderList175: '購入完了商品の総額・内訳の確認は、\nオーダー情報の「詳細」よりご確認いただけます。',
  addCart: 'カートに追加',
  orderList174: '情報変更',
  orderList136: '再発送中',
  orderList137: 'excelファイルとpdfファイルのみアップロードできます',
  orderList138: 'アップロード可能なファイル形式はexcelおよびpdfのみです',
  orderList139: '数量提示をクリアする',
  orderList140: '無料保管中：残り',
  orderList141: '保管費用：',
  orderList142: '保管済',
  orderList143: '最大で5つのファイルをアップロードできます',
  orderList144: '発行中',
  orderList145: '発行完了',
  orderList146: '詳細を見る',
  orderList147: 'ダウンロード',
  orderList148: '商品総数量',
  orderList149: '箱詰め完了',
  orderList150: '箱詰め待ち',
  orderList151: '返品数量',
  orderList152: '廃棄数量',
  orderList153: '箱詰め申請可能',
  orderList154: '発送済み',
  orderList155:
    'ステータスの数量表示をクリアしますか（数量表示のみをクリアし、商品のステータスには影響しません）',
  orderList156: 'リストの調整',
  orderList157: '一括キャンセル',
  orderList158: '【購入不可】の数量表示をクリアしますか',
  orderList159:'①表示列調整',
  orderList160:'表示した内容',
  orderList161:'隠した内容',
  orderList162:'1.左側の列には表示したい内容で、右側の列には隠したい内容です。内容を左側から右側に移入すれば、隠されます。',
  orderList163:'2.左側の列はマウスで上下にドラッグして位置を調整でき、並べ替えることができます。',
  orderList164:'3.調整が完了したら保存をお忘れないでください。',
  orderList165:'クリア済み',
  orderList166:'クリアエラー',
  orderList167:'未知エラー',
  orderList168:'操作がキャンセルされました',
  orderList169:'エラーが発生しました',
  orderList170: "選択した注文をキャンセルしますか？?",
}

t.OrderDetail = {
  OrderDetail1: 'オーダー情報', //
  OrderDetail2: '作成日',
  OrderDetail3: '同梱',
  OrderDetail4: '不良処理中の数量',
  OrderDetail5: '箱タイプ',
  OrderDetail6: 'OPP袋タイプ',
  OrderDetail7: '到着日', //
  OrderDetail8: '交換中数量',
  OrderDetail9: '容積',
  OrderDetail10: 'OPP袋数',
  OrderDetail11: '送信日',
  OrderDetail12: '再発送中数量',
  OrderDetail13: '実重',
  OrderDetail14: '国際物流ステータス',
  OrderDetail15: '画像リンク',
  OrderDetail16: '備考欄',
  OrderDetail17: '商品リンク',
  OrderDetail18: 'アドレス情報', //
  OrderDetail19: '発送者名',
  OrderDetail20: '受取人郵便番号',
  OrderDetail21: '発送者電話',
  OrderDetail22: '受取人電話番号',
  OrderDetail23: 'アドレス番号',
  OrderDetail24: '発送者住所',
  OrderDetail25: '配送先住所',
  OrderDetail26: '料金情報（元、実際の料金は請求書に準じる）',
  OrderDetail27: '国際送料',
  OrderDetail28: '印刷代金',
  OrderDetail29: '代行手数料',
  OrderDetail30: '合計',
  OrderDetail31: '箱代金',
  OrderDetail32: '返品運賃',
  OrderDetail33: '返品手数料',
  OrderDetail34: '基礎検品代金',
  OrderDetail35: '倉庫保管料金',
  OrderDetail36: '廃棄手数料',
  OrderDetail37: 'OPP袋代金',
  OrderDetail38: '検品代金',
  OrderDetail39: 'ラベル代金',
  OrderDetail40: '国内運賃',
  OrderDetail41: 'オーダー詳細', //
  OrderDetail42: '必須', //
  OrderDetail43: '数量は数値のみ入力できます', //
  OrderDetail44: '小数点以下2桁までの数字のみ入力可能です', //
  OrderDetail45: '必須項目を確認するか、入力形式を確認してください', //
  OrderDetail46: '受注の編集', //
  OrderDetail47: '商品代', //
  OrderDetail49: '例外処理料金', //
  OrderDetail50: 'NO', //
  OrderDetail51: '商品名', //
  OrderDetail52: '中国運送状番号', //
  OrderDetail53: '備考欄', //
  OrderDetail54: '画像', //
  OrderDetail55: '品名', //
  OrderDetail56: '差出人郵便番号',
  OrderDetail57: '検品ビデオ',
  OrderDetail58: '交換詳細検品料',
  OrderDetail59: '操作履歴',
  OrderDetail60: '操作前の状態',
  OrderDetail61: '操作後の状態',
  OrderDetail62: '操作ノード',
  OrderDetail63: '操作詳細',
  OrderDetail64: '操作時間',
}

t.OrderBill = {
  OrderBill1: '請求書タイプ',
  OrderBill2: '請求書番号',
  OrderBill3: '項目',
  OrderBill4: '単価',
  OrderBill5: '特典/割引',
  OrderBill6: '金額',
  OrderBill7: '支払総額',
  OrderBill8: '現在の残高',
  OrderBill9: '残高不足です。先にチャージしてください', //
  OrderBill10: '国際送料支払い', //
  OrderBill11: 'チャージ解除', //
  OrderBill12: '注文の支払いを確認しますか？', //
  OrderBill13: '支払いがキャンセルされました', //
  OrderBill14: '閉じますか？', //
  OrderBill15: '注文操作',
  OrderBill16: '国内物流',
  OrderBill17: '国際物流',
  OrderBill18: '検品',
  OrderBill19: '不良数量',
  OrderBill20: '支払時間',
  OrderBill21: '検品動画',
  OrderBill22: '放映',
  OrderBill23: '検品報告書',
}

t.arrivalOrder = {
  arrivalOrder1: '入荷オーダー',
  arrivalOrder2: '注文番号を入力してください', //
  arrivalOrder3: '返品成功', //
}

t.inStorageOrder = {
  inStorageOrder1: '倉庫保管',
  inStorageOrder2: '受取人を入力してください', //
  inStorageOrder3: '一括出荷',
  inStorageOrder4: '並べ替え',
  inStorageOrder5: '少なくとも1つのデータを選択して下さい',
  inStorageOrder6: '出荷の一括申請をしますか？',
  inStorageOrder7: '一括発送を申請', //
  inStorageOrder8: '倉庫保管費用を無料にしますか', //
  inStorageOrder9: '倉庫保管開始時間', //
  inStorageOrder10: '費用計算開始時間', //
  inStorageOrder11: '発送日', //
  inStorageOrder12: '倉庫保管時間（日）', //
  inStorageOrder13: '倉庫保管費用小計(￥)', //
  inStorageOrder14: '倉庫保管費用明細', //
  inStorageOrder15: '本ロット倉庫保管費用合計', //
  inStorageOrder16: '不具合注文/原因/処理方法', //
  inStorageOrder17: '商品数量', //
}

t.badOrder = {
  badOrder1: '返品中',
  badOrder2: '破棄中',
  badOrder3: '不良詳細',
}

t.BuddleOrderDetail = {
  BuddleOrderDetail1: '注文開始日', //
  BuddleOrderDetail2: '日付の選択', //
  BuddleOrderDetail3: '発送日', //
  BuddleOrderDetail4: '発送完了日',
  BuddleOrderDetail5: 'オーダー日',
  BuddleOrderDetail6: '到着日',
  BuddleOrderDetail7: '送信日',
  BuddleOrderDetail8: '商品URL',
  BuddleOrderDetail9: '同梱リストの詳細', //
  BuddleOrderDetail10: 'ユーザー', //
}

t.BuddleOrder = {
  BuddleOrder1: '全部到着',
  BuddleOrder2: '発送中',
  BuddleOrder3: '変更がキャンセルされました',
  BuddleOrder4: '変更完了しました', //
  BuddleOrder5:
    'この同梱ロットの出荷を申請しますか？これによりオーダーの状態が【発送を申し込む】に変更され、以降この同梱に新規注文が入ることはありません', //
  BuddleOrder6: '出荷', //
  BuddleOrder7: '注文番号',
  BuddleOrder8: '注文入荷数',
  BuddleOrder9: '注文数', //
  BuddleOrder10: '配送先住所',
  BuddleOrder11: '配送先情報',
  BuddleOrder12: '発送日',
  BuddleOrder13: 'オーダーの状態',
  BuddleOrder14: 'オーダー作成時間',
  BuddleOrder15: 'オーダー番号',
  BuddleOrder16: '出荷申請',
  BuddleOrder17: 'オーダーの詳細',
  BuddleOrder18: '到着待ち',
  BuddleOrder19: '同梱リスト',
  BuddleOrder20: '選択された列',
  BuddleOrder21: '右へ',
  BuddleOrder22: '未選択列',
  BuddleOrder23: '左へ',
  BuddleOrder24: '支払い請求書', //
  BuddleOrder25: 'オーダーの分割', //
  BuddleOrder26: '国際物流', //
}
t.laund = {
  laund1: 'TOP',
  laund2: '洗濯タグ管理',
  laund3: 'テンプレート名',
  laund4: 'テンプレート名を入力してください',
  laund5: 'リセット',
  laund6: '検索',
  laund7: '新規テンプレート',
  laund8: '商品コピー',
  laund9: '編集',
  laund10: '削除',
  laund11: 'サイズ',
  laund12: '材質',
  laund13: '洗濯注意アイコン標識',
  laund14: '使用上の注意事項',
  laund15: '会社名',
  laund16: '電話番号',
  laund17: 'メール',
  laund18: '作成時間',
  laund19: '備考',
  laund20: 'テンプレートを編集する',
  laund21: 'テンプレートを複製する',
  laund22: 'テンプレートを削除しますか？',
  laund23: '確定',
  laund24: 'キャンセル',
  laund25: '削除がキャンセルされました',
  laund26: '文字数:',
  laund27: '行数：',
  laund28: '使用上の注意事項',
  laund29: '会社名',
  laund30: '電話番号',
  laund31: '水洗マーク',
  laund32: '水洗い記号:',
  laund33: 'ブリーチ記号:',
  laund34: '乾燥記号:',
  laund35: '反転乾燥記号:',
  laund36: 'アイロンマーク:',
  laund37: 'ドライクリーニング処理記号:',
  laund38: 'ウェット洗浄処理記号:',
  laund39: 'テンプレートプレビュー:',
  laund40: '最大行数を超えました!',
  laund41: '正しいメール形式を入力してください。',
  laund42: '洗濯タグテンプレート名称は重複できません。修正してください。',
  laund43: '保存できませんでした',
  laund44: '適切な記号を選択または解除し、テンプレートの追加するか、テンプレートから削除してください',
  laund45: 'この項目は必須です',
  laund46: '住所',
}
t.defe = {
  defe1: '不良品詳細',
  defe2: '内容を入力してください',
  defe3: '作成時間:',
  defe4: '時間の選択',
  defe5: '処理時間:',
  defe6: '処理方法:',
  defe7: '再送運送状番号:',
  defe8: '送り返された運送状番号:',
  defe9: '内容を入力してください',
  defe10: '詳細',
  defe11: '処理待ち',
  defe12: '処理中',
  defe13: '処理完了',
  defe14: 'キャンセル済み',
  defe15: 'リセット',
  defe16: '検索',
  defe17: '並べ替え',
  defe18: '詳細',
  defe19: '换货',
  defe20: '置换',
  defe21: '一部返品する',
  defe22: 'すべて返品する',
  defe23: '部分焼却する',
  defe24: '全部焼却する',
  defe25: '正常に送信する',
  defe26: '商品の詳細',
  defe27: '破損:',
  defe28: '汚れ:',
  defe29: '品違い:',
  defe30: '不足:',
  defe31: '添加',
  defe32: '交換数量:',
  defe33: '返品数',
  defe34: '返品数',
  defe35: '补发数量',
  defe36: '送り状番号の再送',
  defe37: '廃棄数量。',
  defe38: '廃棄数',
  defe39: '返品先',
  defe40: '処理履歷',
  defe41: '番号',
  defe42: '担当者',
  defe43: '処理時刻',
  defe44: '内容',
  defe45: '閉じる',
  defe46: '説明を添える',
  defe47: '交換数量を空欄にはできません',
  defe48: '再発送数を空欄にはできません',
  defe49: '返品数を空欄にはできません',
  defe50: '廃棄数量は空欄にはできません',
  defe51: '処理説明を空欄にはできません',
  defe52: '保存完了',
  defe53: '保存できませんでした',
  defe54:
    '必須項目を空欄にせず、再入力して提出して下さい。',
  defe55: '换货',
  defe56:
    '再発送の送り状番号がない場合、セラーから発送後に必ず再記入してください。弊社経由での購入以外の場合、返品先住所を必ず記入してください。',
  defe57:
    '再発送の送り状番号がない場合、セラーから出荷後に必ず再記入してください。',
  defe58: '置换',
  defe59: '弊社経由での注文以外の場合は、必ず返品先をご記入ください。',
  defe60: '一部返品する',
  defe61: '部分焼却する',
  defe62: '弊社経由での注文以外の場合は、必ず返品先をご記入ください。',
  defe63: 'すべて返品する',
  defe64: '全部焼却する',
  defe65: '正常に送信する',
  defe66:
    '正常出荷を選択すると、不良品の送付を受け入れることを意味します。',
  defe67: '操作',
  defe68: '処理方法',
  defe69: '不良品番号',
  defe70: '作成時間',
  defe71: '数量',
  defe72: '写真1',
  defe73: '不良画像',
  defe74: '不具合状況',
  defe75: '不具合記述',
  defe76: '処理履歴',
  defe77: '処理状態',
  defe78: '処理期日',
  defe79: '送り状番号',
  defe80: '送り状番号の再送',
  defe81: '返品先',
  defe82: '数:',
  defe83: '返品送料:',
  defe84: '送り状番号:',
  defe85: '状態:',
  defe86: '不良数:',
  defe87: '返品手数料:',
  defe88: '送り状番号の再送',
  defe89: '作成時期:',
  defe90: '処理時間:',
  defe91: '廃棄手数料:',
  defe92: '返品先:',
  defe93: '不具合記述:',
  defe94: '取り扱い説明:',
  defe95: 'アップロードをクリック',
  defe96: '注文の詳細',
  defe97:
    'すべての画像のアップロード完了をお待ち頂くか、ページを更新して再アップロードしてください!',
  defe98: '最大3枚の画像をアップロードできます',
  defe99: '不良数量',
  defe100: '例外処理料金',

  defe101: '交換',
  defe102: '返品',
  defe103: '在庫化',
  defe104: '希望する処理方式：',
}
t.addr = {
  addr1: '住所管理',
  addr2: '配送先住所',
  addr3: '輸入責任者住所',
  addr4: '名前',
  addr5: '受取人を入力してください',
  addr6: 'リセット',
  addr7: '検索',
  addr8: '住所新規登録',
  addr9: '番号',
  addr10: '操作',
  addr11: '編集',
  addr12: '削除',
  addr13: '住所番号',
  addr14: 'デフォルト住所',
  addr15: '受取人',
  addr16: '電話',
  addr17: '地域',
  addr18: '詳細住所',
  addr19: '郵便番号',
  addr20: '備考',
  addr21: '新規・編集アドレス',
  addr22: '名前',
  addr23: '名前を入力してください',
  addr24: '携帯電話番号',
  addr25: '電話番号を入力してください',
  addr26: '住所',
  addr27: '省・市・区を選ぶ',
  addr28: '郵便番号',
  addr29: '詳細住所',
  addr30: '住所、通り、番地などの詳細',
  addr31: 'デフォルト住所に設定する',
  addr32: '名前を入力してください',
  addr33: '電話番号を入力してください',
  addr34: '詳細住所を入力してください',
  addr35: '郵便番号を入力してください',
  addr36: '住所番号を入力してください',
  addr37: 'エリアを選んでください',
  addr38:
    '必須項目を空欄にせず、再入力して提出してください。',
  addr39: 'この住所を削除しますか？',
  addr40: '削除がキャンセルされました',
  addr41: '会社名',
  addr42: '法人番号',
  addr43: 'NACSSリアルタイムアカウント(14桁)',
  addr44: 'Email',
  addr45: '会社名を入力してください',
  addr46: '法人番号を入力してください',
  addr47: 'Naccsリアルタイム口座を入力してください',
  addr48: 'メールアドレスを入力してください',
  addr49: '選択された商品の数',
  addr50: '申請商品総重量',
  addr51: '名前',
  addr52: "申請総数量",
}
t.mess = {
  mess1: '受信ボックス',
  mess2: '送信ボックス',
  mess3: '連関番号',
  mess4: 'メッセージタイプ',
  mess5: '発送開始日',
  mess6: '日付を選ぶ',
  mess7: '発送終了日',
  mess8: 'すべて',
  mess9: '未読',
  mess10: '既読',
  mess11: 'リセット',
  mess12: '検索',
  mess13: '既読',
  mess14: '番号',
  mess15: 'Re',
  mess16: 'メッセージ状態',
  mess17: '画像',
  mess18: 'メッセージタイプ',
  mess19: 'オーダー番号',
  mess20: '送受信日時',
  mess21: '件名',
  mess22: '内容',
  mess23: 'メッセージタイプ:',
  mess24: '注文番号：',
  mess25: 'タイトル:',
  mess26: '返信内容:',
  mess27: '画像:',
  mess28: 'アップロードをクリックする',
  mess29: 'タイトルを入力してください',
  mess30: '返信内容を入力してください',
  mess31: '注文メッセージ',
  mess32: 'その他のニュース',
  mess33: '選択して下さい',
  mess34: '返信済み',
  mess35:
    'すべての画像のアップロード完了をお待ち頂くか、ページを更新して再アップロードしてください!',
  mess36: '最大1枚の画像をアップロードできます',
  mess37:
    '最大1枚の画像をアップロードできます。',
  mess38: '返事をしない',
  mess39: '選択済みカラム',
  mess40: '左へ',
  mess41: '右へ',
  mess42: '未選択カラム',
  mess43: '序列',
  mess44: '閉じますか？',
  mess45: '添付ファイル',
  mess46: '履歴対話',
  mess47: '送信者',
  mess48: '私',
  mess49: 'プラットフォーム',
  mess50: '返信済み',
  mess51: 'メッセージ返信',
  mess52: '画像は3枚までアップできる',
  mess53: 'お気に入り',
  mess54: 'お気に入りに追加',
  mess55: 'お気に入りからキャンセル',
  mess56: '通常のメッセージ',
  mess57: 'オーダー変更',
  mess58: 'ロット・メッセージ',
  mess59: '最大9枚の画像をアップロードできます',
  mess60: '既読返信なし',
  mess61: '悪いニュース',
  mess62: 'キーワードを入力して検索',
  mess63: 'オーダー番号/梱包ロット',
  mess64: '制限なし',
  mess65: '発送日時',
  mess66: 'メッセージはありません',
  mess67: '受信者',
  mess68: 'なし',
  mess69: '関連梱包ロット',
  mess70: '以前の会話のトランスクリプト',
  mess71: 'お気に入りに追加しました',
  mess72: '最大9ファイルを選択できます',
  mess73: 'JPG、PNG、MP4、Excel、AI、PDFファイルをアップロードしてください',
  mess74: 'メッセージが送信されました',
  mess75: 'メッセージはありません',
  mess76: '新規メッセージ作成',
  mess77: 'アリパートナーズ',
  mess78: '数字と英字のみ入力できます',
  mess79: '返信',
  mess80: 'オーダー番号が存在しません',
  mess81: 'データ読み込みエラー',
  mess82: 'キーワード',
  resumeName: '名前',
  resumePhoto: '写真',
  resumeBirthday: '生年月日',
  resumeNativePlace: '出身地',
  resumeSchoolMajor: '卒業校/専攻',
  resumeIntroduction: '自己船介'
}

t.payBills = {
  payBills1: '転送', //
  payBills2: '箱詰めにする', //
  payBills3: '同梱', //
  payBills4: '支払総額', //
  payBills5: '支払い済み', //
  payBills6: '残高が不足しています。チャージして下さい', //
  payBills7:
    '注文のステータスが進むごとにメール通知が可能です。通知を受け取りたいステータスにチェックをつけ「保存」をして下さい',
  payBills8: 'リマインダノード', //
  payBills9: '受信メール', //
  payBills10: '購入完了', //
  payBills11: '購入不可', //
  payBills12: '店舗から発送完了', //
  payBills13: '倉庫到着', //
  payBills14: '検品開始', //
  payBills15: '検品完了', //
  payBills16: '不良品検出', //
  payBills17: '不良品処理完了', //
  payBills18: '国際送料支払', //
  payBills19: '国際発送完了', //
  payBills20: 'メール通知設定', //
  payBills21: 'メッセージ受信', //
}

t.filter = {
  filter1: '購入待ち',
  filter2: '購入完了',
  filter3: '入庫待ち',
  filter4: '到着',
  filter5: '検品中',
  filter6: '検品完了',
  filter7: '倉庫に保管中',
  filter8: '発送申請',
  filter9: '不良処理待ち',
  filter10: '不良品交換却下',
  filter11: '交換品返送待ち',
  filter12: '交換して到着を待つ',
  filter13: '一部商品返品待ち',
  filter14: '再送して入荷を待つ',
  filter15: '支払い待ち',
  filter16: '発送待ち',
  filter17: '発送済み',
  filter18: 'キャンセル済み',
  filter19: '返品申請中',
  filter20: '返金待ち',
  filter21: '返品待ち',
  filter22: '返品済み',
  filter23: '廃棄申請中',
  filter24: '廃棄支払い待ち',
  filter25: '一部商品廃棄待ち',
  filter26: '廃棄待ち',
  filter27: '廃棄済み',
  filter28: 'パッキン中',
  filter29: '購入できない',
  filter59: '発送申請待ち',
  filter30: '転送',
  filter31: '荷物',
  filter32: 'レトルト',
  filter33: '段ボール',
  filter34: '外観',
  filter35: '特殊な箱',
  filter36: 'いいえ',
  filter37: 'は',
  filter38: 'ラベルを取り替える',
  filter39: '襟を切る',
  filter40: '襟替え',
  filter41: '水切りシート',
  filter42: '水洗いラベルを取り替える',
  filter43: 'パンチ',
  filter44: '消臭',
  filter45: '乾燥剤',
  filter46: '商品+1ポイント',
  filter47: '寸法ラベルを取り替える',
  filter48: '商品+2ポイント',
  filter49: '商品+その他付属品',
  filter50: '未棚卸し',
  filter51: '棚卸完了',
  filter52: '棚卸しが通らない',
  filter53: '荷物',
  filter54: '受注',
}
t.router = {
  router1: '新規',
  router2: '送り状', //
  router3: 'FBA新規梱包伝票', //
  router4: 'FBA請求書', //
  router5: '資金明細',
  router6: 'メッセージ・リスト', //
  router7: 'チャージ記録',
  router8: '個人情報',
  router9: 'アカウントセキュリティ',
  router10: '登録携帯番号の変更',
  router11: '梱包伝票詳細', //
  router12: '箱の詳細', //
  router13: '不良品倉庫詳細', //
  router14: 'アラーム設定', //
  router15: '新規注文',
  router16: 'プライバシーポリシー',
  router17: '商品リスト',
  router18: '商品詳細',
  router19: '営業日カレンダー',
}

t.businessCalendar = {
  previousMonth: '前月',
  nextMonth: '翌月',
  rakumartHoliday: 'アリパートナーズ休日',
  substituteWork: '振替出勤',
  officeHoliday: '日本事務所休み',
  today: 'きょう',
  loadError: 'カレンダーを読み込めませんでした',
}

t.store = {
  store1: 'すべての注文',
  store2: 'FBA梱包ロット',
  store3: 'チャージ',
  store4: 'フィードバック',
  store5: 'メッセージ通知',
  store6: '洗濯タグ管理',
}

t.select = {
  select1: '商品を選ぶ',
  select2: '選ばれた',
  select3: '商品名',
  select4: '注文番号',
  select5: '検索',
  select6: 'リセット',
  select7: '注文番号',
  select8: '商品名',
  select9: '次の日',
  select10: '到着日',
  select11: '注文状態',
  select12: '選択肢がありません',
  select13: '既に同梱されているものを選択して下さい',
  select14: 'オーダー番号',
  select15: 'オーダー作成時間',
  select16: 'あて先',
  select17: 'オーダーの状態',
  select18: 'すでに同梱されているものに分割する',
  select19: '新たな同梱に切り分ける',
  select20: '操作完了しました',
  select21: '既に同梱されているものを選んでください',
  select22: '最初に選択して下さい',
  select23: '商品を選択して下さい',
  select24: '注文データがありません',
}

t.login = {
  login1: 'ログインID/電話番号/メールアドレス',
  login2: 'ログイン',
  login3: 'ユーザー名を入力してください', //
  login4: 'ログイン成功', //
  login5: 'パスワードを再設定する', //
  login6: '新しいパスワードを設定する', //
  login7: '登録メールアドレスを入力してください', //
  login8: '受信用メールアドレス', //
  login9: '6〜20桁のログインパスワードを設定する', //
  login10: '6〜20桁のログインパスワードを再入力して下さい', //
  login11: 'パスワードは空欄にできません', //
  login12: 'パスワードは6〜16桁でなければなりません', //
  login13: '大文字、小文字、数字のうち2種類以上を入力してください', //
  login14: 'パスワードは空欄にできません', //
  login15: 'パスワードは空欄にできません', //
  login16: '確認コードを入力してください', //
  login17: '確認コードの形式が正しくありません', //
  login18: '送信しました。メールを確認してください', //
  login19: '送信しました。メールを確認してください', //
  login20: 'メールアドレスの形式が正しくありません', //
  login21: '6〜20桁のパスワードを入力してください', //
  login22: 'パスワードを再度入力してください', //
  login23: '同意する', //
  login24: '「利用規約」', //
  login25: '新規登録', //
  login26: 'すでにアカウントをお持ちですか？ログインする', //
  login27: 'ユーザー契約に同意してください', //
  login28:
    '6〜20桁の英数字、または英数字の組み合わせを入力してください', //
  login29: '正しい形式を入力してください', //
  login30: '電話番号を入力してください', //
  login31: '正しい形式を入力してください', //
  login32: 'パスワードを再入力してください', //
  login33: '登録完了', //
  login34: '操作に失敗しました', //
  login35: 'パスワードを保存する', //
  login36: "「プライバシーポリシー」", //
  login37: "プライバシーポリシーに同意します", //
}

t.logistics = {
  logistics1: '追跡情報検索',
  logistics2: 'お問い合わせ番号を入力してください',
  logistics3: '検索',
  logistics4: '詳細',
  logistics5: '配送ステータス',
  logistics6: '最新配送ステータス',
  logistics7: '配送完了日',
  logistics8: 'お問い合せ送り状NO',
  logistics9: '発送日',
  logistics10: '集荷営業所',
  logistics11: '配達営業所',
  logistics12: 'お荷物個数',
  logistics13: '状況',
  logistics14: '日時',
  logistics15: '担当営業所',
  logistics16:
    'お荷物のお届けが完了しました。ご利用ありがとうございました。',
  logistics17: '恐れ入りますが、お問い合せ送り状NOをお確かめください。',
}
t.FBAContainerOrder = {
  FBAContainerOrder1: '空輸',
  FBAContainerOrder2: '海運',
  FBAContainerOrder3: '輸入責任者住所を選択してください',
  FBAContainerOrder4: 'お届け先を選択してください',
  FBAContainerOrder5: 'ルートを選択してください',
  FBAContainerOrder6: '物流会社を選択してください',
  FBAContainerOrder7: '新しい商品を選択してください',
  FBAContainerOrder8: '申請可能商品-エクスポート',
  FBAContainerOrder9: '商品出荷指示一括アップロード',
  FBAContainerOrder10: '注文时间',
}
t.cart = {
  addProduct: '商品を追加',
  addProductHint: '下記の商品情報を選択して、カートに追加してください。',
  editProductInfo: '商品情報を編集',
  editProductInfoHint: '現在の行の商品情報を変更するか、同じ商品の別の種類を追加することができます。',
  confirmEdit: '変更を確定',
  addToNewRow: '別の行に追加',
  dialogPrice: '価格：',
  dialogColor: 'カラー：',
  dialogSize: 'サイズ：',
  dialogQuantity: '数量：',
  cart1: 'カート注文数',
  cart2: 'カート推定金額',
  cart3: '受注予定金額の選択',
  cart4: 'カート内の注文情報が変更されました。保存してから離れますか？',
  cart5: '最終保存日時',
  cart6: '確定',
  cart7: 'すべて選択',
  cart8: 'No',
  cart9: 'をご確認お願いいたします。',
  cart10: '保存',
  cart11: '保存しない',
  cart12: '発注しますか?',
  cart13: '第{0}ページ番号（{1}）',
  cart14: '単価が入力されていないか、0になっています。正しい価格を入力してください',
  cart15: '色を入力下さい',
  cart16: '入力下さい',
  cart17: 'ASINを入力下さい',
  cart18: '洗濯タグを選択下さい',
  cart30: 'キーワードまたは商品リンクを入力して検索してください',
  cart31: '最近の検索',
  cart32: 'タオバオ・天猫',
  cart33: 'カートに追加しました',
  wslang531: '総合ソート',
  wslang441: '売れ高',
  wslang189: '価格',
  wslang190: '価格帯',
  wslang1171: '出荷日',
  wslang377: '検索',
  wslang256: '条件をクリアする',
  wslang1276: '同じ商品をさがす',
  wslang1166: '30日間の売上合計',
  wslang1167: 'リピートオーダー率',
  wslang488: '元',
  wslang726: '約',
  wslang1172: '全部',
  wslang1173: '当日出荷',
  wslang1174: '24時間内に出荷',
  oneEight20: '円表示は参考価格です。正しい金額は決済画面で確認いただけます。',
  wslang375: '数量',
  wslang187: 'カートに追加',
  wslang231: '今すぐ購入',
  wslang347: '商品詳細',
  wslang608: '商品紹介',
  oneEight34: '数量以上',
  downloadTemplateVersion: '最新バージョン更新時間',
  applyMessage22: '受取人の情報の一括選択',
  applyMessage23: '自動発送依頼の一括遥択',
  applyMessage24: '受取人情報',
  applyMessage25: '選択',
  applyMessage26: 'お届け先住所を選択してください。',
  applyMessage27: '受取人情報',
  applyMessage28: '修改发货信息',
  applyMessage29: '配送情報を選択する',
  applyMessage30: '注文する商品を選択してください',
  applyMessage31: '複数の配送情報を一括選択する',
  applyMessage32: 'お届け先住所',
  applyMessage33: 'お届け先情報を選択してください。',
  applyMessage34: '確認',
  applyMessage35: '新規オーダーリストに追加しました。',
}
t.subAddress = {
  subAddress1: '受取人の情報を入力してください',
  subAddress2: '検索',
  subAddress3: '住所を選択',
  subAddress4: '名前：',
  subAddress5: '住所：',
  subAddress6: '郵便番号：',
  subAddress7: '会社名：',
  subAddress8: '備考：',
  subAddress9: '電話：',
  subAddress10: '法人番号：',
  subAddress11: '選択',
  subAddress12: '編集',
  subAddress13: '受取人を入力してください',
  subAddress14: '新しい住所を追加下さい',
  subAddress15: '国：',
  subAddress16: '詳細な住所：',
  subAddress17: 'キャンセル',
  subAddress18: '追加して使用する',
  subAddress19: '変更を保存',
  subAddress20: '名前を入力してください',
  subAddress21: '電話番号を入力してください',
  subAddress22: '省・市・区を選択してください',
  subAddress23: '詳細な住所、通り名、門牌号など',
  subAddress24: '郵便番号',
  subAddress25: '備考',
}
t.switchs = {
  switchs1: '未読メッセージのポップアップ通知：',
  switchs2: '開ける',
  switchs3: '閉じる',
  switchs4: '未読メッセージのポップアップ通知をオフにしますか？オフにすると通知は表示されません。',
}
t.diaMsg = {
  msg1: '未読メッセージがあります：',
  msg2: '既読にして閉じる',
  msg3: '返信',
  msg4: '詳細',
  msg5: 'メッセージ通知へ移行',
  msg6: '全て既読にする',
  msg7: 'アラートを閉じる',
}
t.diaCloseMsg = {
  msg1: 'リマインダ',
  msg2: '未読メッセージのポップアップ通知をオフにしますか？オフにすると通知は表示されません。',
  msg3: '確定',
  msg4: 'キャンセル',
}
t.search = {
  expandPanel: '展開',
  retractPanel: '折畳む',
}
t.message = {
  info: 'すべて既読にしますか？',
}
t.recycle = {
	recycle1: "ゴミ箱",
	recycle2: "状態",
	recycle3: "未読",
	recycle4: "既読",
	recycle5: "すべて",
	recycle6: "会話の数",
	recycle7: "会話が始まった時刻",
	recycle8: "削除時刻",
	recycle9: "ステータスを選択して下さい",
	recycle10: "ユーザー",
	recycle11: "担当者",
	recycle12: "システム",
	recycle13: "全てのメッセージを既読にしますか？",
	recycle14: "はい",
  recycle15: "いいえ",
  recycle16: "選択したメッセージを既読にしますか？",
  recycle17: "利用規約およびプライバシーポリシー改定のお知らせ",
  recycle18: "この度、利用規約およびプライバシーポリシーを改定いたしました。改定後の内容をご確認いただき、ご同意いただいたうえでサービスをご利用くださいますようお願いいたします。",
  recycle19: "改定後の利用規約・プライバシーポリシーは、下記リンクよりご確認いただけます。",
  recycle20: "[利用規約を確認する]",
  recycle21: "[プライバシーポリシーを確認する]",
  recycle22: "内容をご確認のうえ、それぞれにチェックを入れてください。",
  recycle23: "利用規約に同意します",
  recycle24: "プライバシーポリシーに同意します",
  recycle25: "[同意して進む]",
}
t.amazon = {
  amazon01: "アマゾン店舗",
  amazon02: "ショップ名",
  amazon03: "販売者ID",
  amazon04: "アプリID",
  amazon05: "クライアントトークン", //
  amazon06: "クライアントID",
  amazon07: "クライアントシークレット",
  amazon08: "商品",
  amazon09: "商品管理",
  amazon10: "注文管理",
  amazon11: "在庫状況",
  amazon12: "在庫閾値",
  amazon13: "売上高",
  amazon14: "在庫数",
  amazon15: "注文日",
  amazon16: "購入者アカウント", //
  amazon17: "配送方法",
  amazon18: "販売チャネル",
  amazon19: "販売者注文番号",
  amazon20: "紐付け済み",
  amazon21: "未紐付け",
  amazon22: "アラート発生中",
  amazon23: "販売中",
  amazon24: "販売停止中",
  amazon25: "手動同期", //
  amazon26: "データ読み込み中、少々お待ちください",
  amazon27: "標準注文",
  amazon28: "長納期注文",
  amazon29: "予約注文",
  amazon30: "取り寄せ注文",
  amazon31: "受注生産注文",
  amazon32: "処理待ち",
  amazon33: "未発送",
  amazon34: "一部発送",
  amazon35: "発送済み",
  amazon36: "キャンセル済み",
  amazon37: "配送不能",
  amazon38: "請求書未確認",
  amazon39: "在庫待ち",
  amazon40: "配達済み",
  amazon41: "ワンクリック購買",
  amazon42: "ワンクリック出荷",
  amazonDoc: "店舗添加流れ",
};

t.orderGroup = {
  title: 'ご確認ください',
  remove: 'ワンクリック削除',
  confirm: '同意して送信',
  detail: '[{0}]を含む注文：{1}',
  describe: '上記の注文について知り、同意をクリックして送信した後にロットを作成。',
};

export default t
